import { defineMessages, useIntl } from 'react-intl-next';

import UserLimit from '../assets/UserLimit.png';
import PageInsights from '../assets/PageInsights.png';
import PageRestrictions from '../assets/PageRestrictions.png';
import GuestAccess from '../assets/GuestAccess.png';

const i18n = defineMessages({
	standardFeatureUserLimitTitle: {
		id: 'end-of-trial-payment-modals.standard.feature.user-limit.title',
		defaultMessage: 'Unlimited user limit',
		description: 'Unlimited user limit title',
	},
	standardFeatureUserLimitSubtitle: {
		id: 'end-of-trial-payment-modals.standard.feature.user-limit.subtitle',
		defaultMessage: 'Get everyone on the same tool.',
		description: 'Unlimited user limit subtitle',
	},
	standardFeaturePageInsightsTitle: {
		id: 'end-of-trial-payment-modals.standard.feature.page-insights.title',
		defaultMessage: 'Page insights',
		description: 'Page insights title',
	},
	standardFeaturePageInsightsSubtitle: {
		id: 'end-of-trial-payment-modals.standard.feature.page-insights.subtitle',
		defaultMessage: 'See how many people have looked at pages.',
		description: 'Page insights subtitle',
	},
	standardFeaturePageRestrictionsTitle: {
		id: 'end-of-trial-payment-modals.standard.feature.page-restrictions.title',
		defaultMessage: 'Page restrictions',
		description: 'Page restrictions title',
	},
	standardFeaturePageRestrictionsSubtitle: {
		id: 'end-of-trial-payment-modals.standard.feature.page-restrictions.subtitle',
		defaultMessage: 'Choose who can view or edit pages.',
		description: 'Page restrictions subtitle',
	},
	standardFeatureGuestAccessTitle: {
		id: 'end-of-trial-payment-modals.standard.feature.guest-access.title',
		defaultMessage: 'Guest access',
		description: 'Guest access title',
	},
	standardFeatureGuestAccessSubtitle: {
		id: 'end-of-trial-payment-modals.standard.feature.guest-access.subtitle',
		defaultMessage: 'Share pages to external people for free.',
		description: 'Guest access subtitle',
	},
});

export function useGetBenefits(): Record<string, any> {
	const intl = useIntl();

	return {
		unlimitedUserLimit: {
			benefit: intl.formatMessage(i18n.standardFeatureUserLimitTitle),
			explanation: intl.formatMessage(i18n.standardFeatureUserLimitSubtitle),
			img: UserLimit,
		},
		pageInsights: {
			benefit: intl.formatMessage(i18n.standardFeaturePageInsightsTitle),
			explanation: intl.formatMessage(i18n.standardFeaturePageInsightsSubtitle),
			img: PageInsights,
		},
		pageRestrictions: {
			benefit: intl.formatMessage(i18n.standardFeaturePageRestrictionsTitle),
			explanation: intl.formatMessage(i18n.standardFeaturePageRestrictionsSubtitle),
			img: PageRestrictions,
		},
		guestAccess: {
			benefit: intl.formatMessage(i18n.standardFeatureGuestAccessTitle),
			explanation: intl.formatMessage(i18n.standardFeatureGuestAccessSubtitle),
			img: GuestAccess,
		},
	};
}
